export default __webpack_public_path__ + "static/grace-radley-dbe0564d1b66c7f4378c5404c98323f3.svg";